import React from "react"
import DfbHeadline from "../ui-kit/dfb_headline"
import DfbImage from "../ui-kit/dfb_image"
import DfbParagraph from "../ui-kit/dfb_paragraph"
import DfbAnchor from "../ui-kit/dfb_anchor"
import Section from "../blocks/section"
import { SwitchIcon } from "../elements/images/switchIcon"
import { useTranslations } from "../../hooks/useTranslations"

const MCardHighlights = ({ data }) => {
  const { headline, images } = data

  const t = useTranslations()

  return (
    <Section baseClass="m-CardGrid" defaultPaddingTop="medium" data={data}>
      <div className="m-CardGrid-wrapper">
        <div className="m-CardGrid-container">
          {headline && (
            <div className="c-Headline m-CardGrid-headline">
              <DfbHeadline
                headline={data.headline}
                headline_level="h3"
                add_class="c-Headline-strokeLine"
              />
            </div>
          )}
        </div>
        <div className="c-CardGrid">
          <div className="c-CardGrid-container">
            {images.map((item, index) => (
              <div
                className="c-CardGrid-card c-CardGrid-cardFour"
                key={`${item.image_headline}-${index}`}
              >
                <div className="c-CardSwitch c-CardSwitch--highlight">
                  {/* ToDo: Do not render Card if image is missing */
                  /* Please be aware that the image item is an array now! */}
                  {item.image && (
                    <div className="c-CardSwitch-imageContainer">
                      <DfbImage
                        image={item.image[0]}
                        aspect_ratio="3:4"
                        overlay="75"
                        add_class="c-CardSwitch-image u-Image--xs u-Image-cover"
                      ></DfbImage>
                    </div>
                  )}
                  {item.image_headline && (
                    <DfbHeadline
                      headline={item.image_headline}
                      headline_level="h3"
                      add_class="c-CardSwitch-headline"
                    />
                  )}
                  <div className="c-CardSwitch-icon">
                    <SwitchIcon />
                  </div>
                  {item.image?.[0]?.copyright && (
                    <div className="c-CardSwitch-copyright">
                      {item.image?.[0]?.copyright}
                    </div>
                  )}
                  <div className="c-CardSwitch-overlay">
                    <div className="c-CardSwitch-overlay-inner">
                      <div className="c-CardSwitch-overlay-content">
                        {item.image_headline && (
                          <DfbHeadline
                            headline={item.image_headline}
                            headline_level="h3"
                            add_class="c-CardSwitch-overlay-headline u-Theme-dark"
                          />
                        )}
                        {item.image_description && (
                          <DfbParagraph
                            text={item.image_description}
                            tagName="div"
                            add_class="c-CardSwitch-overlay-paragraph u-Theme-dark"
                          />
                        )}
                        {item.image_link_obj && (
                          <>
                            <DfbAnchor
                              link={item.image_link_obj?.url}
                              add_class="c-CardSwitch-overlay-link u-Theme-dark"
                              secondary
                              external={item.image_link_obj?.type !== "page"}
                              text={
                                // image_alternative is the image link title...
                                item.image_alternative ||
                                t("dfb_anchor.readmore")
                              }
                            ></DfbAnchor>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MCardHighlights
